import { memo, useState } from 'react';
import css from './LegalDocumentLinks.module.scss';
import { useLocalization } from '../../context/Localization/localization';
import { LocalizationType } from '../../context/Localization/localization.types';
import { LegalDocumentModal } from './LegalDocumentModal/LegalDocumentModal';
import { LegalDocumentType } from './LegalDocumentModal/LegalDocumentModal.types';
import { LegalDocumentLinksProps } from './LegalDocumentLinks.types';
import { GoMotoComponent } from '../../API/GoMoto.types';

export const LegalDocumentLinks: GoMotoComponent<LegalDocumentLinksProps> = memo(({ className }: LegalDocumentLinksProps) => {
    const Localization: LocalizationType = useLocalization();
    const [openType, setOpenType] = useState<LegalDocumentType | undefined>(undefined);

    return (
        <div className={className ?? css.linksContainer}>
            {Localization.formatString(
                Localization.ViewOurTermsAndPrivacyPolicy,
                <span
                    key={'terms'}
                    className={css.link}
                    onClick={() => setOpenType('terms')}
                    role={'button'}
                    tabIndex={0}
                >
                    {Localization.TermsOfUse}
                </span>,
                <span
                    key={'privacy'}
                    className={css.link}
                    onClick={() => setOpenType('privacy')}
                    role={'button'}
                    tabIndex={0}
                >
                    {Localization.PrivacyPolicy}
                </span>,
            )}
            <LegalDocumentModal
                documentType={openType ?? 'terms'}
                open={openType !== undefined}
                onClose={() => setOpenType(undefined)}
            />
        </div>
    );
});
